import { Suspense } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { Breadcrumbs } from '@/components/features/shared/Breadcrumbs'
import { AuditorViewBanner } from '@/components/features/AuditorViewBanner'
import { AIChatbot } from '@/components/features/AIChatbot'
import { OnboardingChecklist } from '@/components/features/OnboardingChecklist'
import { StandaloneSpotlight } from '@/components/features/FeatureSpotlight'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { TrialBanner } from '@/components/subscription/TrialBanner'

function PageLoadingFallback() {
  return (
    <div className="flex items-center justify-center py-20">
      <div className="animate-spin rounded-full h-8 w-8 border-2 border-muted border-t-certify-600" />
    </div>
  )
}

export function DashboardLayout() {
  const location = useLocation()

  return (
    <div className="min-h-screen bg-background">
      <TrialBanner />
      <AuditorViewBanner />
      <Header />
      <div className="flex">
        {/* Desktop sidebar */}
        <aside className="hidden w-64 md:block">
          <div className="sticky top-14 h-[calc(100vh-3.5rem)]">
            <Sidebar />
          </div>
        </aside>

        {/* Main content */}
        <main className="flex-1 min-w-0 overflow-x-hidden">
          <div className="container py-6 pb-24 sm:pb-6 px-4 sm:px-6 lg:px-8">
            <Breadcrumbs />
            <ErrorBoundary resetKey={location.pathname}>
              <Suspense fallback={<PageLoadingFallback />}>
                <Outlet />
              </Suspense>
            </ErrorBoundary>
          </div>
        </main>
      </div>

      {/* AI Chatbot with Spotlight */}
      <AIChatbot />
      <StandaloneSpotlight
        tourId="ai-chatbot"
        targetSelector='[aria-label="Open AI Assistant"]'
        title="Meet Your AI Assistant"
        description="Ask questions about compliance, get help finding documents, or check what needs attention. Click anytime!"
        position="top"
      />

      {/* Onboarding Checklist Sidebar */}
      <OnboardingChecklist />

      {/* Feedback Widget */}
    </div>
  )
}
